import {ConfigApi} from '@backstage/core-plugin-api';

function getLastPathKey(to: string): string {
  try {
    const url = new URL(to, globalThis.location.origin);
    const segs = url.pathname.split('/').filter(Boolean);
    return segs.length ? `/${segs.at(-1)}` : '/';
  } catch {
    const segs = to.split('/').filter(Boolean);
    return segs.length ? `/${segs.at(-1)}` : to;
  }
}

function findGroupsForPath(serviceGroupMapping: ConfigApi[], to: string): string[] | undefined {
  const key = getLastPathKey(to);
  const match = serviceGroupMapping.find(cfg => cfg.getOptionalString('path') === key);
  return match ? (match.getOptionalStringArray('groups') ?? []) : undefined;
}

/**
 * Decides whether a custom sidebar link is shown.
 *
 * Links whose last path segment is mapped in `gvf.serviceGroupMapping` require
 * one of the configured groups in the user's ownership entity refs. While the
 * refs are unknown (loading or lookup failure), mapped links stay hidden.
 */
export function isSidebarItemVisible(
  to: string,
  serviceGroupMapping: ConfigApi[],
  ownershipEntityRefs: string[] | undefined,
): boolean {
  const allowedGroups = findGroupsForPath(serviceGroupMapping, to);
  if (!allowedGroups || allowedGroups.length === 0) {
    return true;
  }
  if (!ownershipEntityRefs) {
    return false;
  }
  return allowedGroups.some(g => ownershipEntityRefs.includes(g));
}
